export default __webpack_public_path__ + "static/media/2B.b30c34c7.png";